import React, { useState, useEffect } from 'react';
import ShowModal from '../../../../Common/Modal/modal';
import ViewCell from '../../../../Common/Table/ViewCell';
import VistaTable from '../../../../Common/Table/VistaTable';
import WhitelistForm from './whitelistForm';
import whiteListService from './whitelistService';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle , faSearch} from '@fortawesome/free-solid-svg-icons';

export function Whitelist(props) {
    const [showModal, setShowModal] = useState(false);
    const [data, setWhiteListData] = useState([]);
    const {
        customerData: { customerId },
    } = props;

    useEffect(() => {
        (async () => {
            setWhiteListData(await new whiteListService().getAllWhitelistByCustomerId(customerId));
        })();
    }, []);

    const [rowData, setRowData] = useState();

    const whitelistcolumns = [
        {
            Header: 'IP Range Start',
            accessor: 'ipStart',
            Filter: ({filter, onChange}) => filterRender(filter, onChange),
        },
        {
            Header: 'IP Range End',
            accessor: 'ipEnd',
            Filter: ({filter, onChange}) => filterRender(filter, onChange),
        },
        {
            Header: 'Description',
            accessor: 'description',
            Filter: ({filter, onChange}) => filterRender(filter, onChange),
        },
        {
            Header: () => <div style={{ textAlign: 'center' }}>Action</div>,
            Cell: ViewCell,
            getProps: (state, rowInfo) => ({
                onClick: () => {
                    setRowData(rowInfo.original);
                    addWhiteList(rowInfo);
                },
            }),
            className: 'td-button-outer',
            minWidth: 110,
            filterable: false
        },
    ];

    const toggleModel = () => {
        setRowData(null);
        setShowModal(!showModal);
    };

    const addWhiteList = () => {
        setShowModal(!showModal);
    };

    return (
        <div className="model-list-box">
            <div>
                {showModal ? (
                    <ShowModal
                        toggleModel={toggleModel}
                        show={showModal}
                        title="SFTP IP Range"
                        renderModalBody={
                            <WhitelistForm
                                customerId={customerId}
                                data={data}
                                rowData={rowData}
                                setRowData={setRowData}
                                setWhiteListData={setWhiteListData}
                                toggleModel={toggleModel}
                            />
                        }
                    />
                ) : null}
            </div>
            <Button className="add-whitelist-btn text-center btn-sm" onClick={addWhiteList}>
                <FontAwesomeIcon className="btn-icon" icon={faPlusCircle} />
                <span className="ml-2">Add IP Range</span>
            </Button>
            <VistaTable data={data} columns={whitelistcolumns} />
        </div>
    );
}

const filterRender = (filter, onChange) => {
    return (
        <div style={{position: 'relative', backgroundColor: '#FFFFFF', paddingLeft: '10px'}}>
        <FontAwesomeIcon icon={faSearch}  className='filter-search-icon' />
        <input
        onChange={event => onChange(event.target.value)}
        value={filter ? filter.value : ''}
        style={{
            width: '100%',
            border: '0px'
        }}
        autoComplete='none'
        />
    </div>
    )
}


Whitelist.propTypes = {
    customerData: PropTypes.object.isRequired,
};

export default Whitelist;
